<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->

<nz-modal
  [nzVisible]="visible"
  nzTitle="Send feedbacks to therapist"
  nzOkText="Send"
  [nzOkLoading]="sending"
  [nzOkDisabled]="!selectedTherapistId || selectedSessionIds.length === 0"
  (nzOnCancel)="close()"
  (nzOnOk)="send()"
>
  <ng-container *nzModalContent>
    <label class="font-medium mb-1 block">Therapist</label>
    <nz-select
      class="w-full"
      nzShowSearch
      nzPlaceHolder="Select a therapist"
      [(ngModel)]="selectedTherapistId"
    >
      <nz-option
        *ngFor="let therapist of therapistOptions"
        [nzValue]="therapist.value"
        [nzLabel]="therapist.label"
      ></nz-option>
    </nz-select>
    <app-session-feedback-selector
      *ngIf="visible"
      [sessions]="sessions"
      (selectedSessionIdsChange)="selectedSessionIds = $event"
    ></app-session-feedback-selector>
  </ng-container>
</nz-modal>
